import axios from "axios";
import { useEffect, useState } from "react";
import { EVENTS_BASE_URL, EVENT_KEY_INFO } from "../ApiDetails.js";

const KeyInformation = ({ eventId }) => {
    const [eventDetails, setEventDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!eventId) {
            setError("Event is not yet created");
            setLoading(false);
            return;
        }

        const fetchEventDetails = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${EVENTS_BASE_URL}/${eventId}/${EVENT_KEY_INFO}`);
                setEventDetails(response.data);
                setError(null);
            } catch (err) {
                setError("Error fetching EventDetails");
                console.error("Error fetching EventDetails:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchEventDetails();
    }, [eventId]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <>
            <h4 className="pagetitle">Key Information</h4>
            {eventDetails ? (

                <div className="row gx-2">
                    <div className="col bg d-flex">
                        <h4 style={{ fontSize: "17px", paddingTop: "10px" }}>
                            {eventDetails.totalFamilyNum}
                        </h4>
                        <p style={{ paddingTop: "10px" }}>Mars family members</p>

                    </div>
                    <div className="col bg d-flex">
                        <h4 style={{ fontSize: "17px", paddingTop: "10px" }}>
                            {eventDetails.totalCount - 1}
                        </h4>
                        <p style={{ paddingTop: "10px" }}>Visit in this site</p>
                    </div>
                    <div className="col bg d-flex align-items-center">
                        <h4 style={{ fontSize: "17px", whiteSpace: "nowrap" }}>
                            {eventDetails.nextAnniversaryDate ? new Date(eventDetails.nextAnniversaryDate).toLocaleDateString('en-US', {timeZone: 'UTC'}) : "No Date"}
                        </h4>
                        <p style={{ paddingTop: "10px" }}>
                            Upcoming Anniversary
                        </p>
                    </div>
                </div>
            ) : (
                "No Data"
            )}
        </>
    );
};

export default KeyInformation;
